import type { JobStatusPhase } from '@/types/job';

const BILLING_LOCKED_JOB_STATUSES: ReadonlySet<JobStatusPhase> = new Set([
  'CANCELLED',
  'CLOSED',
  'ARCHIVED',
]);

/**
 * Completing the work freezes operational changes, but it starts the final
 * billing step. Keep invoice creation and billing configuration available until
 * the job is actually closed (or otherwise terminated).
 */
export function isJobBillingReadOnly(status: JobStatusPhase): boolean {
  return BILLING_LOCKED_JOB_STATUSES.has(status);
}
